<script>
  function relativeLuminance(hex) {
    const r = parseInt(hex.slice(1, 3), 16) / 255
    const g = parseInt(hex.slice(3, 5), 16) / 255
    const b = parseInt(hex.slice(5, 7), 16) / 255
    const toLinear = (c) => (c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4))
    return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b)
  }

  function contrastRatio(hex1, hex2) {
    const l1 = relativeLuminance(hex1)
    const l2 = relativeLuminance(hex2)
    return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05)
  }

  export default {
    props: {
      collection: {
        type: Object,
        required: true,
      },
    },
    computed: {
      // Small text (14px normal) requires 4.5:1 for AA. If the collection's heroTextColor
      // doesn't reach that against the hero background, fall back to the dark brand color.
      breadcrumbColor() {
        const bg = this.collection.heroColor
        const text = this.collection.heroTextColor
        if (!bg || !text) return text
        if (contrastRatio(bg, text) >= 4.5) return text
        const darkFallback = '#002823'
        return contrastRatio(bg, darkFallback) >= contrastRatio(bg, text) ? darkFallback : text
      },
    },
  }
</script>

<template>
  <section
    class="relative w-full flex items-center justify-center hero-section"
    :style="{ backgroundColor: collection.heroColor }"
  >
    <!-- Breadcrumb: absolutely positioned, constrained to container width -->
    <div v-if="collection.breadcrumb" class="absolute top-0 left-0 right-0">
      <BaseContainer max-width="2xl">
        <nav class="pt-6" aria-label="Breadcrumb">
          <span class="font-body font-medium text-sm" :style="{ color: breadcrumbColor }">
            <RouterLink
              :to="{ name: 'MarketLanding' }"
              class="hover:opacity-80 transition"
              :style="{ color: breadcrumbColor }"
              >Market</RouterLink
            >
            <span class="mx-1" aria-hidden="true">&gt;</span>
            <span class="underline" aria-current="page">{{ collection.breadcrumb }}</span>
          </span>
        </nav>
      </BaseContainer>
    </div>

    <!-- Heading: centered in the full hero -->
    <h1
      class="font-heading font-semibold text-center leading-tight px-6 hero-heading"
      :style="{ color: collection.heroTextColor }"
    >
      {{ collection.title }}
    </h1>
  </section>
</template>

<style lang="postcss" scoped>
  .hero-section {
    min-height: 232px;

    @screen md {
      min-height: 322px;
    }
  }

  .hero-heading {
    font-size: 32px;

    @screen md {
      font-size: 45px;
    }
  }
</style>
